import { render, staticRenderFns } from "./ShareSection.vue?vue&type=template&id=60a5041d&scoped=true&"
import script from "./ShareSection.vue?vue&type=script&lang=js&"
export * from "./ShareSection.vue?vue&type=script&lang=js&"
import style0 from "./ShareSection.vue?vue&type=style&index=0&id=60a5041d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5041d",
  null
  
)

export default component.exports